/**
 * Collection FAQ Accordion Functionality
 * Custom addition for FAQ sections
 */
(function() {
    'use strict';
    
    function initCollectionFAQs() {
        const faqQuestions = document.querySelectorAll('.collection-faq-question');
        
        faqQuestions.forEach(question => {
            // Remove any existing event listeners to prevent duplicates
            question.removeEventListener('click', handleFAQClick);
            question.addEventListener('click', handleFAQClick);
        });
    }
    
    function handleFAQClick(event) {
        event.preventDefault();
        
        const question = this;
        const answer = question.nextElementSibling;
        const isActive = question.classList.contains('active');
        const container = question.closest('.collection-faq-container');
        
        // Close all other FAQ items within the same container
        if (container) {
            const allQuestionsInContainer = container.querySelectorAll('.collection-faq-question');
            allQuestionsInContainer.forEach(otherQuestion => {
                if (otherQuestion !== question) {
                    otherQuestion.classList.remove('active');
                    const otherAnswer = otherQuestion.nextElementSibling;
                    if (otherAnswer) {
                        otherAnswer.classList.remove('active');
                    }
                }
            });
        }
        
        // Toggle current FAQ item
        if (isActive) {
            question.classList.remove('active');
            if (answer) answer.classList.remove('active');
        } else {
            question.classList.add('active');
            if (answer) answer.classList.add('active');
        }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initCollectionFAQs);
    } else {
        initCollectionFAQs();
    }
    
    // Re-initialize for AJAX page loads (common in modern themes)
    document.addEventListener('shopify:section:load', initCollectionFAQs);
    document.addEventListener('page:loaded', initCollectionFAQs);
    
    // For Horizon theme's specific events (if any)
    if (window.theme && window.theme.init) {
        document.addEventListener('theme:loaded', initCollectionFAQs);
    }
})();